export function getStatusText(invoiceProvider: string, statusCode: number) {
  switch (invoiceProvider) {
    case 'quickbooks': {
      // 1 for draft, 3 for sent, 5 for printed, 7 for paid
      switch (statusCode) {
        case 3: {
          return t('sent');
        }
        case 5: {
          return t('printed');
        }
        case 7: {
          return t('paid');
        }
        default: {
          return t('draft');
        }
      }
    }
    // Freshbooks
    default: {
      // 1 for draft, 2 for sent, 4 for paid
      switch (statusCode) {
        case 1: {
          return t('draft');
        }
        case 2: {
          return t('sent');
        }
        case 3: {
          return t('viewed');
        }
        case 4: {
          return t('paid');
        }
        case 5: {
          return t('auto paid');
        }
        case 6: {
          return t('retry');
        }
        case 7: {
          return t('failed');
        }
        case 8: {
          return t('partial');
        }
        default: {
          return t('unknown');
        }
      }
    }
  }
}
